const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5001',
  FRONTEND_BASE_URL: process.env.REACT_APP_FRONTEND_BASE_URL || 'http://127.0.0.1',
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || 'http://127.0.0.1/google/callback',
};

export default config; 